import React from "react";
import moment from "moment/moment";

import { TIME_FORMAT_FRONTEND } from "../../constants";

const TimeStop = ({ stop }) => {
  const startTime = convertToInt(stop?.startTime);
  const endTime = convertToInt(stop?.endTime);
  const arrivalTime = convertToInt(stop?.arrivalTime);
  const finishTime = convertToInt(stop?.finishTime);
  const classArrivalTime = calClassArrivalTime();
  const classFinishTime = calClassFinishTime();
  const isCompleted = ["COMPLETED", "SKIPPED", "PICKUP_FAILED", "DELIVERY_FAILED"].includes(stop.status);

  function convertToInt(time) {
    if (!time) return -1;
    const times = time.split(":");
    return parseInt(times[0]) * 60 + parseInt(times[1]);
  }

  function calClassArrivalTime() {
    if (arrivalTime < 0 && startTime < 0) return "green";
    if (arrivalTime < startTime || arrivalTime > endTime) return "red";
    return "green";
  }

  function calClassFinishTime() {
    if (finishTime < 0 && endTime < 0) return "green";
    if (finishTime < startTime || finishTime > endTime) return "red";
    return "green";
  }

  return (
    <span className="TimeStopContent">
      {!isCompleted && (
        <>
          <span className={classArrivalTime}>{stop?.arrivalTime}</span>
          <span>{" - "}</span>
          <span className={classFinishTime}>{stop?.finishTime}</span>
        </>
      )}
      {isCompleted && (
        <>
          <span className={classFinishTime}>{moment(stop.completedAt).format(TIME_FORMAT_FRONTEND)}</span>
        </>
      )}
    </span>
  );
};

export default TimeStop;
